__turbopack_context__.v({
  "bubble": "styles-module__EqzSiW__bubble",
  "bubble-text-wrapper": "styles-module__EqzSiW__bubble-text-wrapper",
  "circle-content-wrapper": "styles-module__EqzSiW__circle-content-wrapper",
  "circle-content-wrapper-fixed-width": "styles-module__EqzSiW__circle-content-wrapper-fixed-width",
  "circle-wrapper": "styles-module__EqzSiW__circle-wrapper",
  "connect-app-images-grid": "styles-module__EqzSiW__connect-app-images-grid",
  "facebook-logo-wrapper": "styles-module__EqzSiW__facebook-logo-wrapper",
  "fitbit-logo-wrapper": "styles-module__EqzSiW__fitbit-logo-wrapper",
  "giving-page-demo-image-wrapper": "styles-module__EqzSiW__giving-page-demo-image-wrapper",
  "hero-btn-wrapper": "styles-module__EqzSiW__hero-btn-wrapper",
  "hero-content-wrapper": "styles-module__EqzSiW__hero-content-wrapper",
  "hero-image": "styles-module__EqzSiW__hero-image",
  "hero-wrapper": "styles-module__EqzSiW__hero-wrapper",
  "impact-jump-to-button-copy-wrapper": "styles-module__EqzSiW__impact-jump-to-button-copy-wrapper",
  "impact-statement-copy-wrapper": "styles-module__EqzSiW__impact-statement-copy-wrapper",
  "section-wrapper": "styles-module__EqzSiW__section-wrapper",
  "strava-logo-wrapper": "styles-module__EqzSiW__strava-logo-wrapper",
  "top-bubble-mobile-spacer": "styles-module__EqzSiW__top-bubble-mobile-spacer",
});
